type FabContactProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const FabContact = ({className, size = 22, fill = 'currentColor'}: FabContactProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="28 28 24 24"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M29.9065 41.6198C29.764 41.5333 29.6474 41.4102 29.5686 41.2634C29.4899 41.1164 29.452 40.9512 29.4588 40.7847C29.4656 40.6181 29.517 40.4565 29.6075 40.3166C29.698 40.1767 29.8243 40.0636 29.9734 39.989L50.5416 29.4584L45.5668 49.8203C45.5305 49.9666 45.4597 50.1021 45.3604 50.2155C45.261 50.3289 45.136 50.4169 44.9957 50.472C44.8547 50.5284 44.7023 50.551 44.551 50.5379C44.3995 50.5248 44.2533 50.4765 44.124 50.3969L29.9065 41.6198Z" />
        <path d="M39.5243 47.558L36.678 50.4042C36.6122 50.47 36.5284 50.5149 36.4371 50.5331C36.3458 50.5513 36.2512 50.542 36.1652 50.5063C36.0792 50.4708 36.0058 50.4104 35.9541 50.333C35.9024 50.2555 35.8749 50.1645 35.875 50.0715V45.3048L50.5417 29.4584" />
    </svg>
);

export default FabContact;
